import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'page-addons-real-time',
  templateUrl: 'addons-real-time.html',
})
export class AddonsRealTimePage {


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService) {

  }

  close() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/addons/addons-real-time/addons-real-time.ts